import { render, staticRenderFns } from "./swiper-pagination-quarternary.vue?vue&type=template&id=775a25dd&scoped=true&"
import script from "./swiper-pagination-quarternary.vue?vue&type=script&lang=js&"
export * from "./swiper-pagination-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a25dd",
  null
  
)

export default component.exports